import React, { Component } from "react";
import * as classNames from "classnames";
import StackGrid from "react-stack-grid";
import { MediaContainer } from "../mediaContainer/mediaContainer";
import { TickIconSmall } from "../icons/icons";
import styles from "./mediaCarousel.css";

// Extract as carousel instance

class MediaCarousel extends Component {
	onClick(e, selectedImage) {
		this.props.onClick(selectedImage);
	}

	render() {
		const { images, selectedImage, children } = this.props;

		if (!Array.isArray(images) || !images.length) {
			return null;
		}

		return (
			<div className={styles.mediaCarousel}>
				<StackGrid
					columnWidth={"25%"}
					gutterWidth={16}
					gutterHeight={16}
					monitorImagesLoaded={true}
					duration={0}
				>
					{children}
					{images.map((src, index) => (
						<MediaContainer
							className={classNames(
								styles.mediaCarouselItem,
								src === selectedImage ? styles.mediaCarouselItemSelected : null
							)}
							image={src}
							key={index}
							onClick={e => this.onClick(e, src)}
						>
							{src === selectedImage ? (
								<div className={styles.selectionIndicator}>
									<TickIconSmall />
								</div>
							) : null}
						</MediaContainer>
					))}
				</StackGrid>
			</div>
		);
	}
}

export default MediaCarousel;



// WEBPACK FOOTER //
// ./src/components/ui/mediaCarousel/mediaCarousel.js